export default __webpack_public_path__ + "static/media/newbg.97a4d138.jpg";